import Box from '@mui/material/Box';
import AdminPortalApp from '@octopus-admin-portal/App';
import Styled from './SettingsPage.styled';

function SettingsPage() {
  return (
    <Styled.SettingsRoot>
      <Box padding={3}>
        <AdminPortalApp />
      </Box>
    </Styled.SettingsRoot>
  );
}

export default SettingsPage;
